import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from '@table-library/react-table-library/table';
import { CellTree } from '@table-library/react-table-library/tree';
import { useTheme } from '@table-library/react-table-library/theme';
import {
  DEFAULT_OPTIONS,
  getTheme,
} from '@table-library/react-table-library/material-ui';
import { useTree } from '@table-library/react-table-library/tree';
import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material';
import OfflinePin from '@mui/icons-material/OfflinePin';
import { IconButton, Stack, Typography } from '@mui/material';
import { getTitleTree } from 'redux/actions/TitleTree';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import InfoDialog from '../InfoDialog';
import useModal from 'shared/hooks/useModal';

const useStyles = makeStyles((theme) => {
  return {
    customHoverFocus: {
      '&:hover, &.Mui-focusVisible': { backgroundColor: '#00ab4ea3' },
    },
  };
});

const AddressbookTree = ({
  divId,
  multiselect,
  setPayloadOnHide,
  setPilihan,
  pilihan,
  searchText,
  setPersonal,
  useCRSFE,
  closed,
  hideSubDivLpmukp,
  eselon1,
  eselon2
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tmpData = useSelector(({ titleTree }) => {
    return titleTree.detail;
  });
  const [selectedRow, setSelected] = useState(undefined);
  const [data, setData] = useState({ nodes: [] });

  useEffect(() => {
    dispatch(getTitleTree(divId, searchText, useCRSFE, closed, hideSubDivLpmukp));
  }, [divId, searchText]);

  useEffect(() => {
    if (searchText === '') {
      if (!tmpData?.[0]) return;

      const filterFn = (eselon1 && !eselon2) ? (x => x.node === 0)
        : (!eselon1 && eselon2) ? (x => x.node > 0)
          : null;

      const finalNodes = filterFn
        ? tmpData.map(item => ({ ...item, nodes: item.nodes.filter(filterFn) }))
        : tmpData;

      setData({ nodes: finalNodes });
    } else {
      const filterFn = (eselon1 && !eselon2) ? (x => x.level === "2")
        : (!eselon1 && eselon2) ? (x => x.level === "3")
          : null;

      const finalNodes = filterFn
        ? tmpData.filter(filterFn)
        : tmpData;

      setData({ nodes: finalNodes });
    }
  }, [tmpData]);

  // const data = { nodes: tmpData[0] === null ? [] : tmpData };

  let MaterialTheme = getTheme(DEFAULT_OPTIONS);
  let baseCell = MaterialTheme.BaseCell.replace(
    'padding: 16px 16px;',
    'padding: 2px 2px;',
  );
  MaterialTheme['BaseCell'] = baseCell;
  MaterialTheme['Row'] += `
        &.treeRow {
            background-color: #F4F7FE;
        },
        &.columnWidth {
            min-width: 100px;
            max-width: fit-content;
        },
        &.selected {
            background-color: #E6F6EA;
        }
    `;
  MaterialTheme['HeaderRow'] += `
        .th {
          border-bottom: 1px solid #a0a8ae;
          border-right: 1px solid #a0a8ae;
        }
    `;
  MaterialTheme['Table'] += `
    .table {
      padding:0;
    }
  `;
  const theme = useTheme(MaterialTheme);
  const tree = useTree(
    data,
    {
      onChange: onTreeChange,
      state: {
        ids: tmpData[0] === null ? [] : [tmpData ? (tmpData.length > 0 ? tmpData[0].id : null) : null],
      },
    },
    {
      treeIcon: {
        margin: '4px',
        iconDefault: null,
        iconRight: <KeyboardArrowRight />,
        iconDown: <KeyboardArrowDown />,
      },
      indentation: 30,
    },
  );

  function onTreeChange(action, state) {
    // console.log(action, state);
  }

  const handleClick = (node) => {
    if (!node.header) {
      setSelected(node);
      setPersonal(node);
    }
  };

  const handleDoubleClick = (node) => {
    if (!node.header) {
      let tmp = {
        id: node.id,
        text: node.title,
        code: node.code,
        oriItem: node,
      };
      if (multiselect) {
        let exist = pilihan.findIndex((item) => {
          return item.code === tmp.code || item.code === tmp.oriItem?.officer.official.split('/')[1];
        });
        if (exist > -1) {
          setInfo(tmp.text + ' sudah dipilih');
          toggleShowInfo(true);
        } else setPilihan((pilihan) => [...pilihan, tmp]);
      } else {
        setPilihan([tmp]);
        setPayloadOnHide([tmp]);
      }
      setSelected(undefined);
    }
  };

  const timer = useRef();
  const onClickHandler = (node, event) => {
    if (!node.header) {
      clearTimeout(timer.current);
      if (event.detail === 1 && node.id !== selected_id) {
        timer.current = setTimeout(handleClick(node), 100)
      } else if (event.detail === 2) {
        handleDoubleClick(node);
      }
    }
  };


  const {
    stateAddress: stateInfo,
    toggleShow: toggleShowInfo,
    toggleHide: toggleHideInfo,
  } = useModal();
  const [infoMsg, setInfo] = useState('');

  let selected_id = selectedRow ? selectedRow.id : undefined;

  return (
    <>
      {
        tmpData.length === 0 || tmpData === '' || tmpData[0] == null ? (
          <Stack height={'300px'} justifyContent={'center'} alignItems={'center'}>
            <Typography>Tidak ada data</Typography>
          </Stack>
        ) : (
          <Table className="tableaddressbook" size='small' data={data} tree={tree} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell resize>Hierarchy</HeaderCell>
                    <HeaderCell resize>Department</HeaderCell>
                    <HeaderCell resize>Division</HeaderCell>
                    <HeaderCell resize>Organization</HeaderCell>
                  </HeaderRow>
                </Header>

                <Body>
                  {tableList.map((item) => {
                    return (
                      <Row
                        className={
                          selected_id === item.id
                            ? 'selected'
                            : !item.header
                              ? ''
                              : 'treeRow'
                        }
                        key={item.id}
                        item={item}
                        onClick={(node, event) => onClickHandler(node, event)}
                      >
                        <CellTree item={item}>
                          <div style={{ display: 'flex' }}>
                            {selectedRow
                              ? selectedRow.id === item.id && (
                                <div
                                  style={{
                                    padding: '5pt 5pt 5pt 0',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Tooltip title='Select Profile'>
                                    <IconButton
                                      aria-label='select'
                                      onClick={() => handleDoubleClick(item)}
                                      className={classes.customHoverFocus}
                                      sx={{
                                        padding: 0,
                                        position: 'initial',
                                        right: 8,
                                        top: 8,
                                        color: 'black',
                                        fontSize: '20pt',
                                      }}
                                    >
                                      <OfflinePin
                                        style={{
                                          fontSize: '20pt',
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                              )
                              : ''}

                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <div
                                style={{
                                  textAlign: 'left',
                                  fontWeight: '700',
                                  fontSize: '10pt',
                                }}
                              >
                                {
                                  item.officer.delegation_tag && item.officer.delegation_tag !== null && item.officer.delegation_tag !== '' && !useCRSFE ?
                                    'PLH ' + item.title :
                                    item.officer.pgs ? item.officer.pgs + ' ' + item.title :
                                      item.title
                                }
                              </div>
                              <div style={{ textAlign: 'left', fontSize: '10pt' }}>
                                {!item.header && item.officer.official}
                              </div>
                            </div>
                          </div>
                        </CellTree>
                        <Cell>
                          <div style={{ textAlign: 'left', fontSize: '10pt' }}>
                            {!item.header && item.officer.department}
                          </div>
                        </Cell>
                        <Cell>
                          <div style={{ textAlign: 'left', fontSize: '10pt' }}>
                            {!item.header && item.officer.division}
                          </div>
                        </Cell>
                        <Cell>
                          <div style={{ textAlign: 'left', fontSize: '10pt' }}>
                            {!item.header && item.officer.organization}
                          </div>
                        </Cell>
                      </Row>
                    );
                  })}
                </Body>
              </>
            )}
          </Table>
        )
      }
      <InfoDialog
        stateAddress={stateInfo}
        toggleHide={toggleHideInfo}
        msg={infoMsg}
      />
    </>
  );
};

export default AddressbookTree;

AddressbookTree.propTypes = {
  multiselect: PropTypes.bool,
  setPayloadOnHide: PropTypes.func,
  setPilihan: PropTypes.func,
  pilihan: PropTypes.array,
  divId: PropTypes.any,
  searchText: PropTypes.any,
  setPersonal: PropTypes.func,
  useCRSFE: PropTypes.any,
  closed: PropTypes.any,
  hideSubDivLpmukp: PropTypes.bool,
  eselon1: PropTypes.any,
  eselon2: PropTypes.any
};
